import { render, staticRenderFns } from "./editInsureModal.vue?vue&type=template&id=0fc3dc96&scoped=true"
import script from "./editInsureModal.vue?vue&type=script&lang=js"
export * from "./editInsureModal.vue?vue&type=script&lang=js"
import style0 from "./editInsureModal.vue?vue&type=style&index=0&id=0fc3dc96&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc3dc96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc3dc96')) {
      api.createRecord('0fc3dc96', component.options)
    } else {
      api.reload('0fc3dc96', component.options)
    }
    module.hot.accept("./editInsureModal.vue?vue&type=template&id=0fc3dc96&scoped=true", function () {
      api.rerender('0fc3dc96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insure/customInsureManage/editInsureModal.vue"
export default component.exports